import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  DEFAULT_TORCH_CAPTURE_COPY,
  TorchCaptureComponent,
  TorchCaptureCopy,
  TorchUnavailableReason
} from '@jump-tech-frontend/media-capture';

export const TORCH_CAPTURE_CANCELLED = 'cancelled';

export type TorchCaptureDismissal = typeof TORCH_CAPTURE_CANCELLED | TorchUnavailableReason;

@Component({
  selector: 'crds-torch-capture-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TorchCaptureComponent],
  template: `
    <media-capture-torch
      [copy]="copy"
      (captured)="activeModal.close($event)"
      (cancelled)="activeModal.dismiss(cancelledReason)"
      (unavailable)="activeModal.dismiss($event)"
      data-qa="torchCaptureModal"
    ></media-capture-torch>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      media-capture-torch {
        flex: 1 1 auto;
        min-height: 0;
      }
    `
  ]
})
export class TorchCaptureModalComponent {
  @Input() copy: TorchCaptureCopy = DEFAULT_TORCH_CAPTURE_COPY;

  protected readonly activeModal = inject(NgbActiveModal);
  protected readonly cancelledReason = TORCH_CAPTURE_CANCELLED;
}
